import { useMemo } from 'react';
import { REN_NETWORKS_META } from '../../constants';
import { BridgeRenNetworkId, BridgeRenNetworkMeta } from '../../types';

export const useRenNetworkMeta = (networkId?: BridgeRenNetworkId): BridgeRenNetworkMeta | undefined => {
  return useMemo(() => (networkId ? REN_NETWORKS_META.find(({ value }) => value === networkId) : undefined), [networkId]);
};
